import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import ChevronRight16 from '@carbon/icons-react/es/chevron--right/16';
import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { ProjectId } from 'api/models';
import { Panel } from 'components/atoms/collapse';
import { getMembers } from 'data/members/actions';
import { useProjectDetail } from 'data/projects';
import { InviteUserInputV2 } from '../input-v2';
import { Footer } from './footer';
import { Modal, Collapse, MemberList } from './modal.styles';

const COLLAPSE_KEY = 'team_members';

export const GlobalInviteModal = ({
  projectId,
  visible,
  handleOnClose,
}: {
  projectId: number;
  visible: boolean;
  handleOnClose(visibility: boolean): void;
}) => {
  const dispatch = useDispatch();
  const { data: project } = useProjectDetail(ProjectId(projectId));
  const [form] = Form.useForm();
  const [collapseState, setCollapseState] = useState<string[]>([]);

  useEffect(() => {
    dispatch(getMembers());
  }, [dispatch]);

  if (project) {
    return (
      <Modal
        visible={visible}
        title={
          <FormattedMessage
            id="invite.with.label"
            values={{ label: 'people' }}
          />
        }
        onCancel={() => handleOnClose(false)}
        footer={<Footer project={project} clickHandler={handleOnClose} />}
      >
        {project ? (
          <>
            <InviteUserInputV2 project={project} form={form} />
            <Collapse
              expandIconPosition="right"
              expandIcon={({ isActive }) => {
                return isActive ? <ChevronDown16 /> : <ChevronRight16 />;
              }}
              activeKey={collapseState}
              onChange={(activeKeys) =>
                setCollapseState(activeKeys as string[])
              }
            >
              <Panel
                header={
                  <FormattedMessage id="project.invitation.modal.list.title" />
                }
                key={COLLAPSE_KEY}
              >
                <MemberList project={project} />
              </Panel>
            </Collapse>
          </>
        ) : null}
      </Modal>
    );
  }

  return null;
};
